import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import ArrowTop from '../icons/ArrowTop';

const UpArrow = () => {
	const handleEnter = (e) => {
		if (e.keyCode === 13) e.target.click();
	};
	return (
		<ScrollLink
			// className="to-bottom"
			to="welcome"
			smooth={true}
			duration={500}
			onKeyDown={handleEnter}
		>
			<div className="to-start" tabIndex="0">
				{/* <a href={`#${props.link}`} className="no-style"> */}
				{/* <i className="fa fa-arrow-up fa-2x icon" /> */}
				{/* </a> */}
				<ArrowTop />
			</div>
		</ScrollLink>
	);
};

export default UpArrow;



// WEBPACK FOOTER //
// ./src/components/common/UpArrow.js